import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import SubgroupFormFields from "./SubgroupFormFields.js";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        buttonClass: PropTypes.string
    }

    ResetForm() {
        this.setState({
            padre_id: null,
        });
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.subgrupos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Subgrupo ha sido creado con éxito."}
                title={"Nuevo Subgrupo"}
                buttonTitle={"Nuevo Subgrupo"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                onClose={() => this.ResetForm()}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog ui-modal-md"}
            >
                <div className="ui-form">
                    <SubgroupFormFields
                        autoFocusFirstField={true}
                        padreId={this.state.padre_id}
                        onGrupoChange={(data) => this.setState({ padre_id: (data != null ? data.pk : 0) })} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Create.js